<template>
    <div class="content-body" id="tender">
        <div class="row match-height">
            <div class="col-md-12"> 
                       
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title"><i class="icon-price-tags"></i> {{$t('titles.user_messages')}}</h3>
                        <div class="heading-elements">                           
                            <!-- <button type="button" class="btn btn-warning" v-if="$store.state.listRole.client || $store.state.listRole.admin" @click="addTaskCont()">
                                <i style="color: #FFFFFF" class="icon-plus2"></i>
                            </button> -->
                        </div>
                        <!---------------- start filter block -->
                        <div class="row" id="logist-filter">
                            <div class="col-md-12">
                                <fieldset class="position-relative">
                                    <input type="text" class="form-control form-control input" placeholder="" v-model="filterStr" >
                                    <div class="form-control-position" style="top:13px; right:10px;">
                                        <i class="icon-search4 font-medium-4"></i>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <!---------------- and filter block -->
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <div class="user-messages" >
                                <table class="table">
                                    <tr v-for="(item, index) in paginatedData" :key="index">
                                        <td>
                                        <span class="tag" :class="getTrTypeClass(item.type)">{{item.type}}</span><br />
                                        <span class="ms-title"><b>{{item.title}}</b></span><br />
                                        <span class="ms-body" >{{item.text}}</span><br />                                     
                                        </td>                                   
                                        <td>     
                                            <div class="d-flex flex-row ms-data ">
                                                <span><font-awesome-icon class="icon" icon="clock" /></span>
                                                <span class="">{{item.dateSend}}</span> 
                                            </div>                                   
                                    
                                        </td>        
                                    </tr>
                                </table>                          
                            </div>                            
                        </div>
                    </div>

                </div>
                <div  class="" style="text-align: center;">
                    <ul class="pagination">
                        <li class="page-item" v-if="pageNumber > 0">
                            <a class="page-link" @click="pageNumber--" ><i class="icon-arrow-left2"></i></a>
                        </li>
                        
                        <li class="page-item" v-bind:class="{active : (pageNumber == (page - 1))}" v-for="(page, index) in pages" :key="index" >
                            <a v-if="page != '...'" class="page-link" @click="pageNumber = (page - 1)">{{page}}</a>
                            <a v-else class="page-link" :id="index">{{page}}</a>
                        </li>
                        
                        <li class="page-item" v-if="pageNumber < pageCount - 1">
                            <a class="page-link"  @click="pageNumber++"><i class="icon-arrow-right2"></i></a>
                        </li>
                    </ul>
                </div>       
            </div>
        </div>     
    </div> 
</template>
<script>

  export default {
    name: "user_message",
    data(){
      return{
        listOfMessages:[],
        filterStr:"",
        size:7,
        paggSize:5, 
        pageNumber: 0,       
         }    
    },
    methods: {
         getTrTypeClass(val){
             switch(val) {
            case "Розыграш":
                return "tag-success"               
            case "Новый тендер":
                return "tag-info"               
            case "Отмена тендера":
                return "tag-danger"               
          
            }
          
        },
         getAllTender(){                            
                let dataRequest = {guidClient: null};             
                dataRequest.guidClient = this.$store.state.guidClient;           
                this.makeQuery("/portal/getListMessages", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res.data.result){ 
                        this.listOfMessages = res.data.data                    
                    //    console.log(res.data.data);
                    }
                });           
        },
    },
    computed:{
      
      listFiltered: function(){
                let find = this.filterStr.toLowerCase();
                let found1 = false;
                let found2 = false;
                this.pageNumber = 0;

                return this.listOfMessages.filter(item => {
                    if( (find == '') || ((item.title != null) && (item.title.toLowerCase().indexOf(find) > -1)) ){
                        return item;
                    }

                })
            },
            pageCount(){
                let l = this.listFiltered.length, s = this.size;
                return Math.ceil(l/s);
            },
            pages: function(){
                let arr = [];
                for (let i = 0; i < this.pageCount; i++) { 
                    arr[i] = i + 1;
                }
                let divider = Math.trunc(this.paggSize/2);
                let start = this.pageNumber - divider;
                let end = this.pageNumber + divider + 1;
                if (start < 0) {
                    start = 0;
                }
                let final_arr = arr.slice(start,end);
                if ((start + 1) > arr[0]){
                    final_arr.unshift('...');
                }
                if(end < arr[arr.length - 1]){
                    final_arr.push('...');
                }
                return final_arr;
            },
            paginatedData(){
                if (this.sortedData.length > 0){
                    const start = this.pageNumber * this.size,
                        end = start + this.size;
                    return this.sortedData.slice(start, end);
                }
            },
            sortedData: function () {
                return _.orderBy(this.listFiltered, this.sortKey, this.direction);
            },
    },
    created() {},
    mounted(){
        // this.columns['0']['label'] = this.$t('equipm.table.codeModel')
        this.getAllTender();
        
    }
  }
</script>

<style scoped>
#tender fieldset {
  padding: 10px;
}

.ms-data {
    color: rgb(212, 211, 211);
}
.ms-title{}
.ms-body {}
.icon {
    height: 15px;
    width: 15px;
    float: left;   
    margin-top: 5px;
    margin-right: 5px;
    font-size: 11px;
}
.svg {
    overflow: hidden;
    vertical-align: middle;
}
</style> 


// WEBPACK FOOTER //
// src/pages/User_messages.vue